import { createFileRoute } from "@tanstack/react-router";
import { enPhotoRoute } from "@/lib/seo/enPhotoRoute";

export const Route = createFileRoute("/en_/photography/corporate-portraits")(
  enPhotoRoute("/en/photography/corporate-portraits"),
);
